<div class="vehicle-details pt-2" *ngIf="selectedVehicle">
  <form [formGroup]="vehicleDetailsForm">
    <div class="card w-50">
      <div class="card-body">
        <div class="form-group">
          <label for="id">Vehicle ID</label>
          <input
            type="text"
            class="form-control"
            formControlName="id"
            name="id"
            disabled
            [value]="selectedVehicle.VehicleID"
          />
          <label for="registration">Registration</label>
          <input type="text" class="form-control" name="registration" formControlName="registration" />
          <label for="stateOfRegistration">State of registration</label>
          <input
            type="text"
            class="form-control"
            name="stateOfRegistration"
            formControlName="stateOfRegistration"
          />
          <label for="vin"> VIN (Vehicle Identification Number)</label>
          <input type="text" class="form-control" name="vin" formControlName="vin" />
          <label for="description">Short description</label>
          <input
            type="text"
            class="form-control"
            name="description"
            [value]="selectedVehicle.Year + ' ' + selectedVehicle.Make + ' ' + selectedVehicle.Model"
            formControlName="description"
          />
        </div>
      </div>
    </div>
  </form>
</div>
